import type { PixelData } from '@pindd/types'

export function pixelateImage(
  image: HTMLImageElement,
  targetWidth: number,
  targetHeight: number
): PixelData {
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')!

  canvas.width = targetWidth
  canvas.height = targetHeight

  ctx.drawImage(image, 0, 0, targetWidth, targetHeight)
  const imageData = ctx.getImageData(0, 0, targetWidth, targetHeight)
  const pixels: string[][] = []

  for (let y = 0; y < targetHeight; y++) {
    const row: string[] = []
    for (let x = 0; x < targetWidth; x++) {
      const i = (y * targetWidth + x) * 4
      const r = imageData.data[i]
      const g = imageData.data[i + 1]
      const b = imageData.data[i + 2]
      row.push(rgbToHex(r, g, b))
    }
    pixels.push(row)
  }

  return { width: targetWidth, height: targetHeight, pixels }
}

function rgbToHex(r: number, g: number, b: number): string {
  return '#' + [r, g, b].map((x) => x.toString(16).padStart(2, '0')).join('')
}
